<template>
  <v-container :class="MobileSize ? 'mt-3' : 'mx-0'">
    <!-- Mobile -->
    <v-row class="mb-6" v-if="MobileSize">
      <v-col cols="12" md="12" sm="12" xs="12">
        <v-card class="mt-6" max-height="100%" height="100%" style="border-radius: 8px;">
          <v-list nav>
            <v-list-item style="cursor: pointer;">
              <v-list-item-icon>
                <v-icon color="">mdi-storefront</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title @click="changePage('/')" style="font-size: 16px; line-height: 24px;">กลับไปหน้าการซื้อขาย</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item-group color="#27AB9C">
              <v-list-item v-for="(item, i) in items" :key="i" :disabled="item.disable" @click="changePage(item.path)">
                <v-list-item-icon>
                  <v-icon v-text="item.action"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.title" style="font-size: 16px; line-height: 24px;">
                  </v-list-item-title>
                </v-list-item-content>
                <!-- <v-list-item-action v-if="item.title !== 'บริษัท'"> -->
                <v-list-item-action v-if="item.disable !== true">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-list nav>
            <v-list-item-group color="#27AB9C">
              <v-list-item v-for="(item, i) in itemsCompany" :key="i" :disabled="item.disable" @click="changePage(item.path)">
                <v-list-item-icon>
                  <v-icon v-text="item.action"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.title" style="font-size: 16px; line-height: 24px;">
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="item.title !== 'จัดการรายการสั่งซื้อ'">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <!-- </v-navigation-drawer> -->
      <!-- <v-col cols="12" md="9">
        <v-main style="padding: 0px;">
          <v-container>
            <v-card max-height="100%" height="100%" width="100%" class="mt-3">
              <router-view></router-view>
            </v-card>
          </v-container>
        </v-main>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
import { Decode } from '@/services'
export default {
  data () {
    return {
      dataDetail: [],
      items: [],
      itemsCompany: []
      // activeMenu: true,
      // defaultSelect: 0,
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    }
  },
  watch: {
    MobileSize (val) {
      var shopDetail = JSON.parse(localStorage.getItem('shopDetail'))
      if (val === true) {
        this.$router.push({ path: '/sellerMobile?ShopID=' + shopDetail.id + '&ShopName=' + shopDetail.name }).catch(() => {})
      } else {
        this.$router.push({ path: '/seller?ShopID=' + shopDetail.id + '&ShopName=' + shopDetail.name })
      }
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.$EventBus.$on('AuthorityUsers', this.AuthorityUsers)
    this.$on('hook:beforeDestroy', () => {
      this.$EventBus.$off('AuthorityUsers')
    })
  },
  created () {
    //   this.$EventBus.$on('chackAuthorityCompanyMenu', this.chackAuthorityCompanyMenu)
    //   this.chackAuthorityCompanyMenu() ไม่ใช้ ใช้อีกฟังคืชั่นแทน
    //   this.checkPathCompany()
    //   this.SelectPathCompany()
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' })
    } else {
      this.$EventBus.$emit('getPath')
      this.$EventBus.$emit('CheckFooter')
      this.$EventBus.$on('changeNav', this.SelectPath)
      // this.$EventBus.$on('ChangeActiveMenu', this.ChangeActiveMenu)
      var dataShop = {
        id: this.$route.query.ShopID,
        name: this.$route.query.ShopName
      }
      localStorage.setItem('shopDetail', JSON.stringify(dataShop))
      this.AuthorityUsers()
    }
  },
  methods: {
    async AuthorityUsers () {
      if (localStorage.getItem('list_Company_detail') !== null) {
        this.dataDetail = JSON.parse(Decode.decode(localStorage.getItem('list_Company_detail')))
      }
      console.log(this.dataDetail)
      var item1 = [
        { key: 0, action: 'mdi-domain', title: 'บริษัท', disable: true },
        { key: 1, title: this.dataDetail.compant_name_th, disable: true }
      ]
      var item2 = [{ key: 0, action: 'mdi-file-document-outline', title: 'จัดการรายการสั่งซื้อ', disable: true }]
      if (this.dataDetail.can_use_function_in_company.set_company === '1') {
        item1.push({ key: 2, title: 'จัดการข้อมูลบริษัท', path: '/detailCompanyMobile', disable: false })
      }
      if (this.dataDetail.can_use_function_in_company.set_permission === '1') {
        item1.push({ key: 3, title: 'จัดการตำแหน่งภายในบริษัท', path: '/ManagePositionMobile', isDisabled: false })
      }
      if (this.dataDetail.can_use_function_in_company.set_permission === '1') {
        item1.push({ key: 4, title: 'จัดการผู้ใช้งานภายในบริษัท', path: '/ManageCompanyPostionUserMobile', isDisabled: false })
      }
      if (this.dataDetail.can_use_function_in_company.set_permission === '1') {
        item1.push({ key: 5, title: 'ร้านค้าคู่ค้า', path: '/PartnerMobile', isDisabled: false })
      }
      if (this.dataDetail.can_use_function_in_company.report === '1') {
        item1.push({ key: 6, title: 'รายงานรายจ่าย', path: '/ReportMobile', isDisabled: false })
      }
      if (this.dataDetail.can_use_function_in_company.set_company === '1') {
        item1.push({ key: 7, title: 'คูปองและคะแนน', path: '/CompanyCouposAndPointsMobile', isDisabled: false })
      }
      // item2
      if (this.dataDetail.can_use_function_in_company.order === '1') {
        item2.push({ key: 1, title: 'รายการสั่งซื้อ', path: '/orderCompanyMobile', isDisabled: false })
      }
      if (this.dataDetail.can_use_function_in_company.approve_order === '1') {
        item2.push({ key: 2, title: 'จัดการรูปแบบการอนุมัติ', path: '/listApprovePositionMobile', isDisabled: false })
      }
      if (this.dataDetail.can_use_function_in_company.approve_order === '1') {
        item2.push({ key: 3, title: 'จัดการผู้ซื้อองค์กร', path: '/ManageBuyerApproveMobile', isDisabled: false })
      }
      if (this.dataDetail.can_use_function_in_company.approve_order === '1') {
        item2.push({ key: 4, title: 'รายการอนุมัติ', path: '/listApproveOrderMobile', isDisabled: false })
      }
      if (this.dataDetail.can_use_function_in_company.approve_order === '1') {
        item2.push({ key: 5, title: 'รายการอนุมัติการสั่งซื้อ', path: '/ListApproveMobile', isDisabled: false })
      }
      if (this.dataDetail.can_use_function_in_company.order === '1') {
        item2.push({ key: 6, title: 'การร้องขอราคาพิเศษ', path: '/specialPriceBuyerRequestMobile', isDisabled: false })
      }
      if (this.dataDetail.can_use_function_in_company.order === '1') {
        item2.push({ key: 7, title: 'ใบเสนอราคา', path: '/QUCompanyMobile', isDisabled: false })
      }
      if (this.dataDetail.can_use_function_in_company.order === '1') {
        item2.push({ key: 8, title: 'การชำระเงินแบบเครดิตเทอม', path: '/companyListCreditOrderMobile', isDisabled: false })
      }
      if (this.dataDetail.can_use_function_in_company.tracking === '1') {
        item2.push({ key: 9, title: 'ติดตามสถานะสินค้า', path: '/TackingCompanyMobile', isDisabled: false })
      }
      if (this.dataDetail.can_use_function_in_company.refund === '1') {
        item2.push({ key: 10, title: 'ติดตามการคืนสินค้า', path: '/refundCompanyMobile', isDisabled: false })
      }
      if (this.dataDetail.can_use_function_in_company.review === '1') {
        item2.push({ key: 11, title: 'การประเมินความพึงพอใจ', path: '/reviewCompanyMobile', isDisabled: false })
      }
      this.items = []
      this.items = item1
      this.itemsCompany = []
      this.itemsCompany = item2
    },
    changePage (val) {
      console.log(val)
      this.$router.push({ path: `${val}` }).catch(() => {})
    }
    // ChangeActiveMenu (val) {
    //   this.activeMenu = val
    // },
    // SelectPath () {
    //   if (this.$router.currentRoute.name === 'sellerUI') {
    //     this.defaultSelect = 0
    //   } else if (this.$router.currentRoute.name === 'posellerMobileUI' || this.$router.currentRoute.name === 'posellerDetailMobileUI') {
    //     this.defaultSelect = 1
    //   } else if (this.$router.currentRoute.name === 'CurierMobile') { // inventoryUI'
    //     this.defaultSelect = 2
    //   } else if (this.$router.currentRoute.name === 'inventoryUI') {
    //     this.defaultSelect = 3
    //   } else if (this.$router.currentRoute.name === 'designShopUI') {
    //     this.defaultSelect = 4
    //   } else if (this.$router.currentRoute.name === 'supplier_seller') {
    //     this.defaultSelect = 5
    //   } else if (this.$router.currentRoute.name === 'promotion_seller') {
    //     this.defaultSelect = 6
    //   } else if (this.$router.currentRoute.name === 'partner_seller') {
    //     this.defaultSelect = 7
    //   } else if (this.$router.currentRoute.name === 'order_seller') {
    //     this.defaultSelect = 8
    //   } else if (this.$router.currentRoute.name === 'shop') {
    //     this.defaultSelect = 9
    //   } else if (this.$router.currentRoute.name === 'shopAddress') {
    //     this.defaultSelect = 10
    //   } else if (this.$router.currentRoute.name === 'manufacturer_seller') {
    //     this.defaultSelect = 11
    //   } else if (this.$router.currentRoute.name === 'DownloadFilesMobile') {
    //     this.defaultSelect = 7
    //   } else if (this.$router.currentRoute.name === 'dashboardmobile') {
    //     this.defaultSelect = 12
    //   } else if (this.$router.currentRoute.name === 'revenueMobile') {
    //     this.defaultSelect = 13
    //   } else if (this.$router.currentRoute.name === 'returnMobile') {
    //     this.defaultSelect = 14
    //   } else if (this.$router.currentRoute.name === 'SettingPartnerRequestMobile') {
    //     this.defaultSelect = 15
    //   } else if (this.$router.currentRoute.name === 'SettingTierMobile') {
    //     this.defaultSelect = 16
    //   } else if (this.$router.currentRoute.name === 'QuotationSettingSellerMobile') {
    //     this.defaultSelect = 17
    //   } else if (this.$router.currentRoute.name === 'EtaxCredentailMobile') {
    //     this.defaultSelect = 18
    //   } else if (this.$router.currentRoute.name === 'MerchantShopMobile' || this.$router.currentRoute.name === 'ManagaCuponMobile') {
    //     this.defaultSelect = 19
    //   }
    // }
  }
}
</script>

<style scoped>
.v-application ul, .v-application ol {
    padding: 0px 0px !important;
}
.v-application ol, .v-application ul {
    padding: 0px 0px !important;
}
</style>
<style>
/* .ant-layout-header {
  padding: 0px !important;
}
.ant-popover-inner-content {
    padding: 0px 0px !important;
} */
.pd-link {
  padding-right: 10px;
}
/* #components-layout-demo-top-side-2 {
  margin-top: -14px;
} */
</style>
